"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ReviewReportRequiresApprovalModel () {
        return ReviewReportRequiresApprovalModel;
    },
    get ReviewReportRequiresApprovalOptions () {
        return ReviewReportRequiresApprovalOptions;
    }
});
const _zod = /*#__PURE__*/ _interop_require_default(require("zod"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const ReviewReportRequiresApprovalOptions = [
    "managers-and-admins",
    "admins-only"
];
const ReviewReportRequiresApprovalModel = _zod.default.enum(ReviewReportRequiresApprovalOptions).nullable();
